export default __webpack_public_path__ + "assets/1fe66e66779f14d68e0f103a7abb9f40.png";